module.exports = __webpack_public_path__ + "img/ppt.5f5b3943.png";